<template>
    <UBadge :color="config.color" variant="subtle" :label="config.label" />
</template>

<script setup lang="ts">
import { DoctorStatus } from '~/types/telemedicine'

const props = defineProps<{
    status: DoctorStatus
}>()

const STATUS = {
    [DoctorStatus.draft]: { color: 'gray', label: 'Draft' },
    [DoctorStatus.published]: { color: 'green', label: 'Published' },
    [DoctorStatus.suspended]: { color: 'red', label: 'Suspended' },
} as const

const config = computed(() => STATUS[props.status] ?? STATUS[DoctorStatus.draft])
</script>
